<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <!-- 文件列表 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4"
                 :sm="12">
            <a-form-item label="应用名称">
              <a-input v-model="query.appName"
                       placeholder="请输入应用名称"
                       allow-clear />
            </a-form-item>
          </a-col>

          <a-col :md="8"
                 :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px"
                        @click="resetList">重置</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="addOrUpdateHandle()"
                        v-action:add>新增</a-button>
              <a-button type="danger"
                        style="margin-left: 8px"
                        @click="deleteSelectRow()"
                        v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id"
             :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
             :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
             :data-source="list"
             :columns="columns"
             :loading="dataListLoading"
             :pagination="pagination"
             @change="pageChange">
      <template slot="statusAction"
                slot-scope="text">
        <a-tag color="green"
               v-if="text==1">上线</a-tag>
        <a-tag color="red"
               v-else>下线</a-tag>
      </template>
      <span slot="action"
            slot-scope="text, record">
        <a @click="edit(record)"
           v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal title="操作"
             style="top: 20px"
             :width="800"
             v-model="addOrUpdateVisible"
             @ok="handleOk"
             @cancel="handleCancel">

      <a-form class="log-form"
              :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="访问地址">
          <a-input placeholder="访问地址"
                   v-decorator="['accessUrl',{ rules: [{ required: true, message: '请输入访问地址' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="应用名称">
          <a-input placeholder="应用名称"
                   v-decorator="['appName',{ rules: [{ message: '请输入应用名称' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="应用类型">
          <a-input placeholder="应用类型"
                   v-decorator="['appType',{ rules: [{message: '请输入应用类型' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="应用编码">
          <a-input placeholder="应用编码"
                   v-decorator="['appCode',{ rules: [{message: '请输入应用应用编码' }] }]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="logo地址">
          <a-input placeholder="logo地址"
                   v-decorator="['logoUrl']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="状态">
          <a-select placeholder="请选择"
                    v-decorator="['status',{initialValue:1},{ rules: [{ required: true, message: '请选择状态' }] }]">
            <a-select-option :value="1">上线</a-select-option>
            <a-select-option :value="2">下线</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="排序">
          <a-input-number :formatter="limitNumber"
                          :parser="limitNumber"
                          v-decorator="['sort',{ rules: [{type:'number',pattern:'/[^\d]/g',required: true, message: '请输入数字'}]}]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="备注">
          <a-input placeholder="备注"
                   v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const columns = [
  {
    title: '应用名称',
    dataIndex: 'appName'
  },
  {
    title: '应用编码',
    dataIndex: 'appCode'
  },
  {
    title: '应用类型',
    dataIndex: 'appType'
  },
  {
    title: '访问地址',
    dataIndex: 'accessUrl'
  },
  {
    title: 'logo地址',
    dataIndex: 'logoUrl'
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'statusAction' }
  },
  {
    title: '排序',
    dataIndex: 'sort'
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },

  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'LogList',
  data () {
    return {
      currentId: '',
      queryUrl: '/manager/apps/page',
      deleteUrl: '/manager/apps',
      addOrUpdateUrl: '/manager/apps',
      query: {
        appName: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },

  created () { },
  methods: {
    detailInfo (record) {
      this.detailForm = { ...record }
    },
    edit (record) {
      console.log('123', record)
      this.isUpdate = true
      this.currentId = record.id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.addOrUpdateForm.setFieldsValue(record)
      })
    },
    // handleOk() {

    // },
    handleCancel () { }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
